import React, { useEffect, useState } from "react";
import Select, { components } from 'react-select';
import CreatableSelect from 'react-select/creatable';

const getCustomStyles = hasLabel => ({
    control: (provided, state) => ({
      ...provided,
      minHeight: '45px',
      borderRadius: '8px',
      fontSize: hasLabel ? '15px' : '13px',
      borderColor: state.isFocused ? '#4D3DAB' : '#DDD9F0',
      borderWidth: '1px',
      boxShadow: state.isFocused ? '0 0 0 3px rgba(77, 61, 171, 0.16)' : 'none',
      transition: 'border-color 150ms ease, box-shadow 150ms ease',
      '&:hover': {
        borderColor: state.isFocused ? '#4D3DAB' : '#A89EDF',
      },
    }),
    valueContainer: provided => ({
      ...provided,
      minHeight: hasLabel ? '43px' : provided.minHeight,
      padding: hasLabel ? '19px 15px 4px' : provided.padding,
      alignItems: hasLabel ? 'flex-start' : provided.alignItems,
    }),
    singleValue: provided => ({
      ...provided,
      margin: 0,
      color: '#1A1530',
      fontSize: hasLabel ? '15px' : provided.fontSize,
    }),
    input: provided => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    menu: provided => ({
      ...provided,
      zIndex: 10,
      borderRadius: '12px',
      border: '1px solid #DDD9F0',
      boxShadow: '0 4px 12px rgba(26, 21, 48, 0.08), 0 2px 4px rgba(26, 21, 48, 0.04)',
      overflow: 'hidden',
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: '13px',
      backgroundColor: state.isSelected ? '#4D3DAB' : state.isFocused ? '#F5F4FB' : 'transparent',
      color: state.isSelected ? '#fff' : '#1A1530',
      ':active': {
        backgroundColor: state.isSelected ? '#4D3DAB' : '#EDEAF7',
      },
    }),
    multiValue: provided => ({
      ...provided,
      backgroundColor: '#EDEAF7',
      borderRadius: '6px',
    }),
    placeholder: provided => ({
      ...provided,
      color: '#9B9B9B',
      margin: 0,
      fontSize: hasLabel ? '15px' : provided.fontSize,
    }),
})

export const InputSelect = ({label, value, options, change, isMulti, isDisabled, loading, noOptionsText, setSearch, removeMargin, filterOption, formatOptionLabel, styles, isClearable, onCreateOption, formatCreateLabel, placeholder}) => {
    const [option, setOption] = useState(null);
    const hasLabel = Boolean(label);
    // Com onCreateOption o select passa a aceitar valores novos, digitados na
    // hora (ex.: criar uma tag sem sair da tela da assinatura).
    const SelectComponent = onCreateOption ? CreatableSelect : Select;

    useEffect(() => {
        if(!isMulti){
            let arr = options ? options.filter(opt => opt.value === value) : [];
            setOption(arr[0]);
        } else {
            let arr = options ? options.filter(opt => value.includes(opt.value)) : [];
            setOption(arr);
        }
    }, [value, options]);

    const handleOnChange = value => {
        if(!isMulti){
            // value é null quando o campo é limpo (isClearable).
            change(value?.value ?? null);
            return;
        } else {
            let values = [];
            (value ?? []).map(option => values.push(option.value));
            change(values);
        }
    }

    const NoOptionsMessage = props => {
        return (
          <components.NoOptionsMessage {...props}>
            <span className="custom-css-class">{noOptionsText ?? 'Nenhum resultado'}</span> 
          </components.NoOptionsMessage>
        );
    }

    const getFilterOption = () => {
        if (typeof filterOption === 'function') return filterOption;
        if (filterOption === true) return () => true;
        return undefined;
    };

    return (
        <div className={`select-group${hasLabel ? ' has-label' : ''}`} style={removeMargin ? { margin: 0} : {}}>
            {hasLabel &&
                <label>{label}</label>
            }
            <SelectComponent
                isMulti={isMulti ? true : false}
                isDisabled={isDisabled || loading === true ? true : false}
                isClearable={isClearable ? true : false}
                onCreateOption={onCreateOption}
                formatCreateLabel={formatCreateLabel}
                components={{ NoOptionsMessage }}
                placeholder={loading === true ? 'Carregando...' : (placeholder ?? 'Selecione...')}
                value={Array.isArray(option) ? option :  options.filter(function(option) {
                    return option.value === value;
                })}
                options={options ? options : []}
                formatOptionLabel={formatOptionLabel ?? (item => (
                    <div className="select-label">
                        {item?.image}
                        {item.label}
                    </div>
                ))}
                onInputChange={(value, action) => {
                    if(setSearch && action.action === 'input-change'){
                        setSearch(value)
                    }
                    }}
                onChange={handleOnChange}
                styles={{ ...getCustomStyles(hasLabel), ...(styles || {}) }}
                filterOption={getFilterOption()}
            />
        </div>
    );
}

export default InputSelect;
